import  "./SingaporeSmashEvent2024.css"

const SingaporeSmashEvent2024 = ()=>{
    
    return (
    <>        
     
    </>
    )
}

export default SingaporeSmashEvent2024;